/**
 * Capture current video frame and composite with drawing overlays (MagicBox-compatible).
 */

export function captureVideoFrame(video: HTMLVideoElement | null): string | null {
  if (!video) return null;
  if (video.videoWidth === 0 || video.videoHeight === 0) return null;

  try {
    const canvas = document.createElement('canvas');
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    const ctx = canvas.getContext('2d');
    if (!ctx) return null;
    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
    return canvas.toDataURL('image/jpeg', 0.8);
  } catch (error) {
    console.error('Failed to capture video frame:', error);
    return null;
  }
}

export function compositeDrawingWithFrame(
  frameThumbnailDataUrl: string,
  drawingDataUrl: string
): Promise<string> {
  return new Promise((resolve, reject) => {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    if (!ctx) {
      reject(new Error('Could not get canvas context'));
      return;
    }

    const frameImg = new Image();
    const drawingImg = new Image();
    let loaded = 0;

    const onBoth = () => {
      loaded += 1;
      if (loaded < 2) return;

      canvas.width = frameImg.width;
      canvas.height = frameImg.height;
      ctx.drawImage(frameImg, 0, 0);
      ctx.drawImage(drawingImg, 0, 0, canvas.width, canvas.height);

      const composite = canvas.toDataURL('image/jpeg', 0.85);
      if (!composite?.startsWith('data:image/')) {
        reject(new Error('Failed to generate composite data URL'));
        return;
      }
      resolve(composite);
    };

    frameImg.onload = onBoth;
    drawingImg.onload = onBoth;
    frameImg.onerror = () => reject(new Error('Failed to load frame thumbnail'));
    drawingImg.onerror = () => reject(new Error('Failed to load drawing'));

    frameImg.src = frameThumbnailDataUrl;
    drawingImg.src = drawingDataUrl;
  });
}
